import AddCardCCBill from "@components/AddCardCCBill";

const AddCard = ({ isOpen, toggle, isAdding, isModal }) => {
  return (
    <AddCardCCBill
      isAdding={isAdding}
      toggle={toggle}
      isOpen={isOpen}
      isModal={isModal}
    />
  );
};

export default AddCard;
